export default ({
  path  : process.env.NODE_ENV === 'development'
    ? 'http://localhost/SEIF_TechBossSLIM/public'
    : 'https://slim.seif.safetytrack.co/',
  sApiKeyMap: "AIzaSyAsGgRnC34wiGutlNDOOhb83VzdlZzr1i4"
})
